import KunLoading92 from './src/index'

KunLoading92.install = function (Vue) {
	Vue.component(KunLoading92.name, KunLoading92);
}

export default KunLoading92;
